import React, { Fragment, useEffect, useState } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as toastActions } from '../../../store/ducks/toast';
import { Creators as configActions } from '../../../store/ducks/config-section';
import { ModalAddTime } from './components/ModalAddTime';
import { ModalExcludeTime } from './components/ModalExcludeTime';
import { CircularProgressIndicator } from '../../../components-reactjs/CircularProgressIndicator';
import { LightBlueButton } from '../../../components-reactjs/LightBlueButton';
import { TimeExclude } from './components/TimeExclude';
import { getHorarios, inactiveDay } from '../api';

import { SECTIONS } from '../../../constants/configuracao-horarios';

import {
    ScrollConfig,
    WarningDisabled,
    TextContainer,
    Text,
    TextClickable,
    ConfigContainer,
    ItemContainer,
    CheckBoxContainer,
    DayCheckBox,
    TimeCheckBoxButton,
    TimeContainer
} from './styles';

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...toastActions, ...configActions }, dispatch);

export const EntregaRetirada = connect(
    null,
    mapDispatchToProps
)(({ idTipoEntregaRetirada, addToast, selectSection, selectTab }) => {
    const [fgAtivo, setFgAtivo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [scheduleState, setScheduleState] = useState([]);
    const [selectedDay, setSelectedDay] = useState({});
    const [shouldAddModalOpen, setShouldAddModalOpen] = useState(false);
    const [shouldExcludeModalOpen, setShouldExcludeModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});

    const changeActivatedStatus = async (index, item) => {
        let newObject = { ...item };
        newObject.fgAtivo = !item.fgAtivo;

        if (item.horarios.length) {
            try {
                const response = await inactiveDay({
                    idTipoEntregaRetirada,
                    fgAtivo: newObject.fgAtivo,
                    tpDiaSemana: newObject.tpDiaSemana
                });

                if (response.status === 200) {
                    addToast({
                        text: 'Horário alterado com sucesso',
                        more: 'OK',
                        theme: 'success'
                    });
                }
            } catch (error) {
                addToast({
                    text: error.errorMessage,
                    more: 'OK',
                    theme: 'error'
                });
            }
        }

        const newState = [...scheduleState];
        newState[index] = newObject;

        setScheduleState([...newState]);
    };

    const removeTime = (dayIndex, timeIndex) => {
        const newDay = [...scheduleState][dayIndex];
        newDay.horarios.splice(timeIndex, 1);

        const newState = [...scheduleState];
        newState[dayIndex] = newDay;

        setScheduleState(newState);
    };

    const renderAddModal = () => {
        if (!selectedDay) return;
        return (
            <Fragment>
                <ModalAddTime
                    idTipoEntregaRetirada={idTipoEntregaRetirada}
                    useValues={[scheduleState, setScheduleState]}
                    selectedDay={selectedDay}
                    useModalValues={[shouldAddModalOpen, setShouldAddModalOpen]}
                />
            </Fragment>
        );
    };

    const renderExcludeModal = () => {
        return (
            <Fragment>
                <ModalExcludeTime
                    idTipoEntregaRetirada={idTipoEntregaRetirada}
                    selectedDay={selectedDay}
                    horario={itemToDelete}
                    useValues={[scheduleState, setScheduleState]}
                    excludeHandler={() => removeTime(itemToDelete)}
                    modalValues={[
                        shouldExcludeModalOpen,
                        setShouldExcludeModalOpen
                    ]}
                />
            </Fragment>
        );
    };

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            const horarios = await getHorarios(idTipoEntregaRetirada);
            setScheduleState(horarios.diasSemana);
            setFgAtivo(horarios.fgAtivo);

            setIsLoading(false);
        }

        fetchData();
    }, [idTipoEntregaRetirada]);

    const renderConfig = () => {
        return (
            <Fragment>
                {!!scheduleState &&
                    scheduleState.map((item, dayIndex) => (
                        <ItemContainer key={dayIndex}>
                            <CheckBoxContainer>
                                <TimeCheckBoxButton
                                    type="button"
                                    onClick={() =>
                                        changeActivatedStatus(dayIndex, item)
                                    }
                                >
                                    <DayCheckBox
                                        onChange={() => {}}
                                        checked={item.fgAtivo || false}
                                    />
                                    {item.dsDiaSemana}
                                </TimeCheckBoxButton>
                            </CheckBoxContainer>

                            <TimeContainer>
                                {item.horarios.map((horario, timeIndex) => (
                                    <TimeExclude
                                        disabled={!item.fgAtivo}
                                        key={timeIndex}
                                        start={horario.horaInicio.substr(0, 5)}
                                        end={horario.horaFim.substr(0, 5)}
                                        excludeHandler={() => {
                                            setSelectedDay(item);
                                            setShouldExcludeModalOpen(true);
                                            setItemToDelete(horario);
                                        }}
                                    />
                                ))}
                                {item.fgAtivo && (
                                    <LightBlueButton
                                        label="+ Adicionar horário"
                                        onClick={() => {
                                            setSelectedDay(item);
                                            setShouldAddModalOpen(true);
                                        }}
                                    />
                                )}
                            </TimeContainer>
                        </ItemContainer>
                    ))}
            </Fragment>
        );
    };

    return isLoading ? (
        <CircularProgressIndicator />
    ) : (
        <ScrollConfig className="scroll-config">
            <Fragment>
                {shouldAddModalOpen && renderAddModal()}
                {shouldExcludeModalOpen && renderExcludeModal()}

                {!fgAtivo && (
                    <WarningDisabled>
                        <TextContainer>
                            <Text>Atenção! A </Text>
                            <TextClickable
                                onClick={() => {
                                    selectSection({
                                        selectedSection:
                                            SECTIONS.CONFIGURAR_PEDIDOS
                                    });
                                    selectTab({
                                        idTipoEntregaRetirada
                                    });
                                }}
                                blue={true}
                            >
                                &nbsp;
                                {idTipoEntregaRetirada === 1
                                    ? 'entrega '
                                    : 'retirada '}
                                está desabilitada
                            </TextClickable>
                        </TextContainer>

                        <Text>
                            As alterações feitas aqui entrarão em vigor quando a
                            {idTipoEntregaRetirada === 1
                                ? ' entrega '
                                : ' retirada '}
                            for habilitada novamente.
                        </Text>
                    </WarningDisabled>
                )}

                <ConfigContainer>{renderConfig()}</ConfigContainer>
            </Fragment>
        </ScrollConfig>
    );
});
